import React, { useMemo } from 'react'
import { Row, Col, Stack } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faLocationDot, faPhone, faEnvelope, faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { MapProvider, Map } from 'react-google-store-locator'
import { formatStoreAddress } from '/src/components/commerce/store/util'

const storeHashMap = {
  // mc Northgate
  '4100': 'https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/2025-02/Feb-March-Northgate-DIGITAL-1.pdf',
  // mc Toowoomba
  '4110': 'https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/2025-02/Feb-March-twmba-DIGITAL-1.pdf',
  // mc Bundaberg 
  '4170': 'https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/2025-02/Feb-March-Bundy-DIGITAL-1.pdf',
  // mc Dubbo
  '8216': 'https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/2025-02/Feb-March-Dubbo-DIGITAL-1.pdf',
  // Orrcon Brisbane
  '4080': 'https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/2025-02/Feb-March-Northgate-DIGITAL-1.pdf',
  // mc Tamworth
  '2170': 'https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/2025-02/Feb-March-Tamworth-DIGITAL-1.pdf',
  // mc Charters towers
  '8421': 'https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/2025-02/Feb-March-Charters-DIGITAL-2.pdf',
  // orrcon Carins
  // '4240': '',
  // Orrcon Sydney
  '2070': 'https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/2025-02/Feb-March-Tamworth-DIGITAL-1.pdf',
  // Orrcon Albany
  // '6110': '',
  // mc Kewdale
  // '6100': '',
  // Orrcon Perth
  // '6010': '',
  // mc Geelong
  '8312': 'https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/2025-02/Feb-March-Geelong-DIGITAL-1.pdf',
  // mc Dandenong
  '8303': 'https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/2025-02/Feb-March-Dandenong-digital-1.pdf',
  // mc Morwell
  '3150': 'https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/2025-02/Feb-March-Morwell-DIGITAL-1.pdf',
  // mc Bendigo
  '3130': 'https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/2025-02/Feb-March-Bendigo-Digital-1.pdf',
  // Orrcon Geelong
  '3120': 'https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/2025-02/Feb-March-Geelong-DIGITAL-1.pdf',
  // mc Ottoway
  '5100': 'https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/2025-02/Feb-March-Ottoway-DIGITAL-1.pdf',
  // Orrcon Adelaide
  '5070': 'https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/2025-02/Feb-March-Ottoway-DIGITAL-1.pdf',
  // Orrcon Melb
  '3070': 'https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/2025-02/Feb-March-Dandenong-digital-1.pdf'
}

/*{catalogueLink && (
  <Stack gap={3} direction="horizontal" className="mb-4">
    <a id="storeSalesCatalogue" target="_blank" href={catalogueLink} className="ButtonUnstyled-root button outline">
      {name} Sales Catalogue
      <FontAwesomeIcon icon={faFilePdf} />
    </a>
  </Stack>
)}*/

export const StoreView = ({ 
  name,
  dsap_plant_id,
  field_mc_location,
  field_mc_store_address,
  field_mc_store_delivery_estimate,
  field_mc_store_description,
  field_mc_store_email,
  field_mc_store_opening_times,
  field_mc_store_phone_number,
  field_mc_store_pickup_estimate,
  feature
}) => {
  const onCallNowHandler = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'onCallNowEvent'
    })
  }

  /*const catalogueLink = useMemo(() => {
    if (storeHashMap.hasOwnProperty(dsap_plant_id)) {
      return storeHashMap[dsap_plant_id]
    }
    return false
  }, [dsap_plant_id])*/

  return (
    <>
      <Row>
        <Col sm={6}>
          <ul className="store-values mb-4">
            <li>
              <FontAwesomeIcon icon={faLocationDot} />
              {formatStoreAddress(field_mc_store_address)}
            </li>
            <li>
              <a href={`tel:${field_mc_store_phone_number}`}>
                <FontAwesomeIcon icon={faPhone} />
                {field_mc_store_phone_number}
              </a>
            </li>
            <li>
              <a href={`mailto:${field_mc_store_email}`}>
                <FontAwesomeIcon icon={faEnvelope} />
                {field_mc_store_email}
              </a>
            </li>
            <li>
              {field_mc_store_opening_times}
            </li>
          </ul>
          <Stack gap={3} direction="horizontal" className="mb-4">
            {field_mc_location && (
              <a target="_blank" href={`https://www.google.com/maps?q=${field_mc_location.lat},${field_mc_location.lon}`} className="ButtonUnstyled-root button outline">
                Directions
                <FontAwesomeIcon icon={faArrowRight} />
              </a>
            )}
            {field_mc_store_phone_number && (
              <a target="_blank" href={`tel:${field_mc_store_phone_number}`} onClick={() => onCallNowHandler()} className="ButtonUnstyled-root button outline">
                Call Now
                <FontAwesomeIcon icon={faPhone} />
              </a>
            )}
          </Stack>
          <p>{field_mc_store_description}</p>
        </Col>
        <Col sm={6}>
          <MapProvider stores={feature}>
            <Map 
              options={{
                libraries: ['places'],
                googleMapsApiKey: 'AIzaSyC2p8rYLgOAbU9SjjfPTuv01LWyLi-WHbA'
                // googleMapsApiKey: 'AIzaSyCNqnueGt-wt6vHqZxrWeocQgJIh0EkmbM'
              }}
              googleMapProps={{
                zoom: 10,
                mapContainerStyle: {
                  width: '100%',
                  height: '400px'
                },
                center: {
                  lat: field_mc_location.lat,
                  lng: field_mc_location.lon
                },
              }} 
            />
          </MapProvider>
        </Col>
      </Row>
    </>
  )
}

export default StoreView